export default __webpack_public_path__ + "static/media/Marianne-Light.edc38ef1.woff";